import React, { Component } from "react";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class CommissionEarned extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      modal_center: false,
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "Commission Earned", link: "#" },
      ],
    };
    this.tog_center = this.tog_center.bind(this);
  }

  tog_center() {
    this.setState((prevState) => ({
      modal_center: !prevState.modal_center,
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  show() {
    this.setState({ visible: true });
  }
  hide() {
    this.setState({ visible: false });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Commission Earned"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <div className="table-responsive">
                      <Table bordered className="mb-0">
                        <thead>
                          <tr>
                            <th>Bill ID</th>
                            <th>Execution Date</th>
                            <th>Commision Earned</th>
                            <th>Payment Status</th>
                            <th>Ref. ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td onClick={this.tog_center}>2356</td>
                            <td>12/11/2021</td>
                            <td>Rs. 1235</td>
                            <td>
                              <button className="btn download-bill">
                                Request Payment
                              </button>
                            </td>
                            <td>5265895775</td>
                          </tr>
                          <tr>
                            <td>2356</td>
                            <td>12/11/2021</td>
                            <td>Rs. 1235</td>
                            <td>
                              <button className="btn download-bill">
                                Request Payment
                              </button>
                            </td>
                            <td>5265895775</td>
                          </tr>
                          <tr>
                            <td>2356</td>
                            <td>12/11/2021</td>
                            <td>Rs. 1235</td>
                            <td>
                              <button className="btn download-bill">
                                Request Payment
                              </button>
                            </td>
                            <td>5265895775</td>
                          </tr>
                        </tbody>
                      </Table>
                      <Modal
                        isOpen={this.state.modal_center}
                        toggle={this.tog_center}
                        centered={true}
                      >
                        <ModalHeader
                          toggle={() => this.setState({ modal_center: false })}
                        >
                          Bill ID: 2356
                        </ModalHeader>
                        <ModalBody>
                          <div className="table-responsive">
                            <Table bordered className="mb-0">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Buyer Name</strong>
                                  </td>
                                  <td>Raghav</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Share Name</strong>
                                  </td>
                                  <td>AGS Transact</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Quantity</strong>
                                  </td>
                                  <td>1200</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Settlement Amount</strong>
                                  </td>
                                  <td>Rs. 65800</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Execution Date</strong>
                                  </td>
                                  <td>12/11/2021</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </ModalBody>
                      </Modal>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default CommissionEarned;
